export const FETCH_ALL_CALENDAR_REQUEST = "calendarReducer/FETCH_ALL_CALENDAR_REQUEST";
export const FETCH_ALL_CALENDAR_SUCCESS = "calendarReducer/FETCH_ALL_CALENDAR_SUCCESS";
export const FETCH_ALL_CALENDAR_FAILED = "calendarReducer/FETCH_ALL_CALENDAR_FAILED";
export const FETCH_ALL_CALENDAR_RESET = "calendarReducer/FETCH_ALL_CALENDAR_RESET";


